import { TagResponse } from '@layouts/pages/Settings/general/tags/services/responses/tag.response';

/// Ganhou, perdeu ou segue em aberto: fato do lead, não da coluna.
export enum ELeadOutcome {
    Open = 0,
    Won = 1,
    Lost = 2,
}


/// Por onde o anúncio trouxe o lead (mesmos números do backend).
export enum ELeadSourceDetail {
    MetaLeadForm = 1,
    FacebookLeadForm = 2,
    InstagramLeadForm = 3,
    InstagramAdMessage = 4,
    WhatsAppAdMessage = 5,
    MessengerAdMessage = 6,
}

export enum ELeadSource {
    Manual = 0,
    WhatsApp = 1,
    AdClick = 2,
    Website = 3,
    Instagram = 4,
    Email = 5,
    TikTok = 6,
    Telegram = 7,
    Sms = 8,
    Import = 9,
    RdStation = 10,
}

export interface LeadResponse {
    id: string;
    columnId: string;
    statusId: string;
    contactName: string;
    contactPhone: string;
    contactEmail?: string | null;
    description?: string | null;
    /// Valor estimado; nulo quando ninguém preencheu, pois zero diria que não vale nada.
    value?: number | null;
    /// Quanto fechou de verdade; quando existe, manda no card e nos relatórios.
    closedValue?: number | null;
    /// Quando se espera fechar, como yyyy-MM-dd. Só data, sem hora.
    expectedCloseDate?: string | null;
    outcome: ELeadOutcome;
    outcomeAt?: string | null;
    lossReasonId?: string | null;
    lossReasonName?: string | null;
    lossNote?: string | null;
    procedureName?: string | null;
    source: ELeadSource;
    /// Título do anúncio que originou o lead, quando veio de campanha.
    sourceCampaign?: string | null;
    sourceAdId?: string | null;
    sourceDetail?: ELeadSourceDetail | null;
    /// Conversa no Chatwoot, quando o lead nasceu de um canal.
    chatwootConversationId?: number | null;
    chatwootInboxId?: number | null;
    statusName: string;
    statusColor: string;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
    nextScheduleId?: string | null;
    nextScheduledAt?: string | null;
    lastMessage?: string | null;
    lastMessageAt?: string | null;
    /// Atendente responsável; nulo é um lead na fila, sem dono.
    assignedUserId?: string | null;
    assignedUserName?: string | null;
    /// Cor do avatar do responsável, sorteada quando o usuário foi criado.
    assignedUserColor?: string | null;
    /// Por nome. Vazio quando o lead não tem tag.
    tags: TagResponse[];
    /// Só os preenchidos; vêm na tela do lead e na lista paginada, o quadro manda vazio.
    customFieldValues: LeadCustomFieldValueResponse[];
}

/// Valor no formato do tipo do campo (ver custom-field-value.ts).
export interface LeadCustomFieldValueResponse {
    customFieldId: string;
    value: string;
}

export interface LeadStageResponse {
    id: string;
    name: string;
    sortOrder: number;
}

/// Números do bloco Resumo, prontos do backend (o front não tem o histórico para calcular).
export interface LeadSummaryResponse {
    daysInFunnel: number;
    daysInStage: number;
    openActions: number;
    doneActions: number;
}

export interface LeadDetailResponse {
    lead: LeadResponse;
    boardId: string;
    boardName: string;
    stages: LeadStageResponse[];
    summary: LeadSummaryResponse;
    /// A empresa da pessoa do contato, quando há.
    company?: { id: string; name: string } | null;
}

/// O mínimo para escolher um lead numa lista; o seletor não precisa de valor, etapa nem desfecho.
export interface LeadOptionResponse {
    id: string;
    contactName: string;
    contactPhone: string;
    columnName?: string | null;
}
